function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Tabs } from 'mkui-fd';
import PropTypes from 'prop-types';
var TabPane = Tabs.TabPane;
export default function TransferTabs(props) {
  var _data = [];

  var data = props.data,
      dataMap = props.dataMap,
      prefixCls = props.prefixCls,
      others = _objectWithoutProperties(props, ["data", "dataMap", "prefixCls"]);

  var label = dataMap.label,
      key = dataMap.key;

  if (typeof data === 'string') {
    _data = [{
      label: data,
      key: 0
    }];
  } else {
    _data = data;
  }

  if (_data.length <= 0) {
    return null;
  }

  return React.createElement(Tabs, _extends({
    className: prefixCls
  }, others), _data.map(function (item) {
    return React.createElement(TabPane, {
      tab: item[label],
      key: item[key]
    });
  }));
}
TransferTabs.defaultProps = {
  prefixCls: 'mkui-abstract-transfer-tabs',
  dataMap: {
    label: 'label',
    key: 'key'
  }
};
TransferTabs.propTypes = {
  prefixCls: PropTypes.string
};
//# sourceMappingURL=Tabs.js.map
